/* eslint-disable no-console */
/* eslint-disable no-else-return */
import * as duckdb from "@duckdb/duckdb-wasm";

async function instantiate() {
  try {
    const isProd = process.env.REACT_APP_ENV === "production";
    const CDN_BUNDLES = duckdb.getJsDelivrBundles();
    const bundle = await duckdb.selectBundle(CDN_BUNDLES);
    const workerUrl = URL.createObjectURL(
      new Blob([`importScripts("${bundle.mainWorker}");`], {
        type: "text/javascript"
      })
    );
  
    const worker = new Worker(workerUrl);
    const logger = new duckdb.ConsoleLogger(`${isProd ? "NONE" : 'DEBUG'}`);
    const db = new duckdb.AsyncDuckDB(logger, worker);
  
    await db.instantiate(bundle.mainModule, bundle.pthreadWorker);
    URL.revokeObjectURL(workerUrl);
  
    return db;
  } catch(error) {
    console.log('Unable to initialize DuckDB: ', error.message);
    return null;
  }
}

const dropAllTables = async (db) => {
  if (db) {
    const conn = await db.connect();
    const result = await conn.query(`SELECT table_name FROM information_schema.tables WHERE table_schema='main';`);
    const tables = result.toArray().map(row => row.table_name);

    await Promise.all(tables.map(async (table) => {
      await conn.query(`DROP TABLE ${table};`);
    }));

    await conn.close();
  }
}

async function createTable(db, tableName, data, columnKeys, columnInfo) {
  const conn = await db.connect();
  try {
    if (!data.length) {
      throw new Error('No data to create table');
    }

    let columns;
    if (columnInfo) {
      columns = columnKeys.map((key) => {
        const columnType = columnInfo.find(column => column?.name === key)?.type;
        return `"${key}" ${columnType}`;
      }).join(', ');
    } else {
      const firstRow = data[0];
      columns = columnKeys.map(key => {
        const value = firstRow[key];
        if (typeof value === 'number') {
          return `"${key}" FLOAT`;
        } else if (typeof value === 'boolean') {
          return `"${key}" BOOLEAN`;
        } else {
          return `"${key}" VARCHAR`;
        }
      }).join(', ');
    }

    const createTableQuery = `CREATE TABLE IF NOT EXISTS "${tableName?.toUpperCase() || tableName}" (${columns});`;
    await conn.query(createTableQuery);
    console.log('Table created successfully');
  } catch (error) {
    console.log('Error during dynamic table creation: ', error.message);
    // throw new Error('Failed to create table ' + tableName + ': ' + error.message);
  }
  return conn;
}

async function insertData(conn, tableName, columnKeys, data = []) {
  try {
    if (!data.length) {
      throw new Error('No data to insert');
    }
    
    const values = data.map(row => {
      const rowValues = columnKeys.map(key => {
        const value = row[key];
        if (value === null || value === undefined) {
          if (typeof value === 'string') {
            return "''";
          } else if (typeof value === 'number') {
            return 0;
          } else {
            return 'NULL';
          }
        }
        return typeof value === 'string' ? `'${value.replace(/'/g, "''")}'` : value;
      }).join(', ');
      return `(${rowValues})`;
    }).join(', ');

    const query = `INSERT INTO "${tableName?.toUpperCase() || tableName}" (${columnKeys?.map(key => `"${key}"`)?.join(',')}) VALUES ${values};`;
    await conn.query(query);
    console.log('Data inserted successfully');
  } catch (error) {
    console.log('InsertData : Error during data insertion: ', error.message);
  }
}

async function queryDB(conn, tableName, query) {
  try {
    // const resultQuery = await conn.query(`SELECT *, (${query}) AS newColumn FROM ${tableName};`);
    const resultQuery = await conn.query(query);
    const result = resultQuery.toArray().map(row => row.toArray());

    return result?.map(row => row?.[0]);
  } catch (error) {
    console.log('QueryDb : Error during query execution: ', error);
    throw new Error(`Query execution failed: ${error.message}`);
  }
}

async function fetchAllData(conn, tableName) {
  try {
    const resultQuery = await conn.query(`SELECT * FROM "${tableName?.toUpperCase() || tableName}";`);
    const result = resultQuery.toArray().map(row => row.toJSON());
    if (result && result.length > 0) {
      return result;
    } else {
      console.log('No data found in the table.');
      return []; // Return an empty JSON array if no data is found
    }
  } catch (error) {
    console.log('FetchAllData : Error fetching data: ', error.message);
    // toast.error(`FetchAllData : Failed to fetch data from ${  tableName  }: ${  error.message}`);
    return [];
  }
}

export default {
  createTable,
  dropAllTables,
  insertData,
  instantiate,
  // initializeDB,
  queryDB,
  fetchAllData
};
